export default __webpack_public_path__ + "static/media/fire.122078df.png";